import { getQuarter } from 'date-fns'
import { CustomFootFallDateRange } from 'src/atoms/custom-polygon'
import { convertDateToString, getDateWithoutBloodyTZ } from 'src/utils/date-utils'

export const getQuartersFromDates = (start: Date, end: Date): CustomFootFallDateRange[] => {
  const startWithNoTZ = getDateWithoutBloodyTZ(start.toISOString())
  const startYear = startWithNoTZ.getFullYear()
  const endWithNoTZ = getDateWithoutBloodyTZ(end.toISOString())
  const endMonth = endWithNoTZ.getMonth() + 1
  const endYear = endWithNoTZ.getFullYear()

  // What is the first quarter? 0-3
  const startQuarter = getQuarter(startWithNoTZ) - 1
  // How many quarters are there between the start and end dates?
  const quarters = (endYear - startYear) * 4 + Math.floor(endMonth / 3)

  const quartersArray = []
  for (let i = startQuarter; i < quarters; i++) {
    const quarterStart = new Date(startYear, i * 3, 1)
    const quarterEnd = new Date(startYear, i * 3 + 3, 0)

    quartersArray.push({
      start: convertDateToString(quarterStart),
      end: convertDateToString(quarterEnd),
    })
  }
  return quartersArray
}
